import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withComponentName } from '../../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../../common/sync-component/Const';
import { syncComponentSelector } from '../../../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../../helpers/EventEmitter';
import { changeCode, REDUCER_NAME } from '../../reducer';
import { SearchFilter } from '../../../../common/search-filter';
import IndexSumary from './index-summary';
import './index.scss';
import { withComponentId } from './../../../../common/ComponentIdContext';
import { compose } from 'redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../../../app/commonReducer';

class SearchBox extends Component {
  componentDidMount() {
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  onSyncSearch = data => {
    const { syncType, changeCode, componentId } = this.props;
    if (
      syncType === TYPE_DISABLE ||
      data.syncType !== syncType ||
      data.search.isIndex ||
      data.search.isDerivatives ||
      !data.search.isTicker
    ) {
      return;
    }
    changeCode(data.search, componentId);
  };

  clickItemSearch = code => {
    const { changeCode, componentId, syncType } = this.props;

    changeCode(code, componentId);
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: code,
    });
  };

  render() {
    const {
      id,
      currentSearch: tmpCurrentSearch,
      indexSumary,
      indexSumaryRealTime,
      listOrganizationByOrganCode,
    } = this.props;

    const isRealTime =
      Object.keys(indexSumaryRealTime).length &&
      indexSumary.organCode === indexSumaryRealTime.organCode;

    const indexSumanyToProp = isRealTime ? indexSumaryRealTime : indexSumary;

    const currentSearch =
      listOrganizationByOrganCode[tmpCurrentSearch.code] || tmpCurrentSearch;

    return (
      <div className="search-box-wrapper">
        <SearchFilter
          schema={[
            { key: 'displayCode', className: 'w-20' },
            { key: 'codeName', className: 'w-55 text-truncate' },
            {
              key: 'exchange',
              className: 'w-25 text-right',
              render: text => {
                return text.toUpperCase();
              },
            },
          ]}
          listKeyFilter={['displayCode', 'codeName']}
          getListSearchFromRedux={state =>
            state[COMMON_REDUCER_NAME].listOrganizationSearch
          }
          currentSearch={currentSearch}
          mainKey={'code'}
          sortKey={'displayCode'}
          clickItemSearch={this.clickItemSearch}
          customWidth={170}
        />

        <IndexSumary
          id={id}
          indexSumaryRealTime={indexSumanyToProp}
          isRealTime={isRealTime}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {
  changeCode,
};

const mapStateToProps = (state, { componentId, componentName }) => {
  return {
    currentSearch:
      state[REDUCER_NAME].listMultiComponent[componentId].currentSearch,
    indexSumary:
      state[REDUCER_NAME].listMultiComponent[componentId].indexSumary,
    indexSumaryRealTime:
      state[REDUCER_NAME].listMultiComponent[componentId].indexSumaryRealTime,
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
    syncType: syncComponentSelector(state, componentName, componentId),
  };
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(SearchBox);
